module.exports = __webpack_public_path__ + "img/error-circle-exclamation.45997fbe.svg";